module.exports = __webpack_public_path__ + "img/Belize.07f20196.png";